<!-- App navigation bar -->
<ng-container *ngIf="config$ | async as config">
  <app-nav></app-nav>

  <aside
    class="app-sidebar"
    [ngClass]="{
      loading: !config.dataLoading.success,
      active: config.sidebarIsOpen
    }"
  >
    <app-search [(value)]="searchVal"></app-search>
    <app-search-list [searchVal]="searchVal"></app-search-list>
  </aside>

  <section class="app-content">
    <app-parts-view [pageId]="pageId"></app-parts-view>
  </section>

  <app-parts [config]="config" [ngClass]="{ visible: config.isBasketVisible || config.isPartsVisible }"></app-parts>
</ng-container>
